const addReadMore = (el) => {
  const element = document.createElement("p");
  element.innerText = "Read more...";
  element.style.textDecoration = "underline";
  element.style.color = "#5e5e5e";
  element.style.cursor = "pointer";
  element.addEventListener("click", () => toggle(el, element));
  el.appendChild(element);
};

const toggle = (parentElement, element) => {
  if (element.innerText === "Read more...") {
    element.innerText = "Read less...";
    return [...parentElement.children].map((el, i) => {
      if (i == 0) {
        el.classList.remove("p__readmore");
      }
      el.style.display = "block";
    });
  } else {
    element.innerText = "Read more...";
    [...parentElement.children].map((el, i) => {
      if (i == 0) {
        el.classList = "p__readmore";
      }
      i >= 1 && i !== parentElement.children.length - 1 ? (el.style.display = "none") : el;
    });
  }
};

const showAllText = (textElement, readMoreElement) => {
  readMoreElement.innerText = "Read less...";
  element.addEventListener("click", () =>
    [...textElement.children].forEach((el) => (el.style.display = "none"))
  );
  return [...textElement.children].forEach((el) => (el.style.display = "block"));
};

const forEachEl = (el) => {
  el.forEach((el) => {
    if (el.children.length >= 0) {
      [...el.children].map((elChild, i) => {
        if (i == 0) {
          elChild.classList = "p__readmore";
        }
        if (i >= 1) {
          elChild.style.display = "none";
        }
      });
      addReadMore(el);
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname.includes("/products")) {
    console.log("Running script - products");
    let testimonialsContainer = [...document.querySelectorAll("section")].filter(
      (container) => !!container.querySelector("slide-show")
    )[0];

    if (testimonialsContainer.length >= 1) {
      testimonialsContainer = testimonialsContainer.filter(
        (section) => !!section.querySelector(".testimonial")
      )[0];
    }

    const blockQuoteElements = testimonialsContainer.querySelectorAll("blockquote");
    forEachEl(blockQuoteElements);
  } else if (window.location.pathname.includes("/collections")) {
    console.log("Running script - collection");
    let collectionContainer = document
      .querySelector(".collection-banner__content")
      .querySelectorAll("p");

    console.log("Collection container: ", collectionContainer, collectionContainer.length);

    if (collectionContainer.length > 1) {
      let pEl = [];
      pEl.push(collectionContainer[0].parentElement);

      console.log("Collection container: FILTER ", pEl);

      forEachEl(pEl);
    }
  }
});
